import { isTag, isElementNode } from 'anodum';
import view from '../../view';
import constants from '../constants';
import getGlobalBySource from '../accessors/get-global-by-source';

const isElementGlobal = (elementId, globalId = null) => {
  const element = view.accessors.getStaticElement(elementId);
  const isGlobal = isElementNode(element) && isTag(element, constants.GLOBAL_TAG_NAME);

  if (!globalId || !isGlobal) {
    return isGlobal;
  }

  const source = element.getAttribute('src');
  const { id } = getGlobalBySource(source);

  return id === globalId;
};

export default isElementGlobal;
